import {
  useWSModalCustom,
  WSModal,
  WSModalCustomProps,
  WSText
} from "@wingspanhq/fe-component-library";
import React from "react";

type Props = {
  documentName: string;
  year: number;
} & WSModalCustomProps<boolean>;

const ModalRequestTaxDocument: React.FC<Props> = props => (
  <WSModal
    title={`Generate ${props.year} ${props.documentName}?`}
    size="S"
    onClose={props.onClose}
    actions={{
      buttons: [
        {
          kind: "Secondary",
          label: "Cancel",
          type: "button",
          onClick: () => props.onClose(false)
        },
        { label: "Request", onClick: () => props.onClose(true) }
      ]
    }}
  >
    <WSText>
      Requests will be processed within 24 hours and sent to your email.
    </WSText>
  </WSModal>
);

export const useModalRequestTaxDocument = () =>
  useWSModalCustom(ModalRequestTaxDocument);
